import {
  HandMetal, RefreshCw, ScrollText, Volume2, VolumeX, PowerOff, Loader2,
} from 'lucide-react';

// Page action-bar CARD — title strip + log / refresh / sound / disconnect-all.
export default function ManualActionBar({
  isAr, connectedCount, accountsCount,
  refreshing, onRefresh,
  soundEnabled, onToggleSound,
  disconnecting, onDisconnectAll,
  onOpenLog,
}) {
  return (
    <div
      className="rounded-2xl border border-white/10 bg-gradient-to-r from-emerald-500/[0.05] to-white/[0.02] p-4 flex items-center justify-between flex-wrap gap-3"
      data-testid="manual-action-bar"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
          <HandMetal className="h-5 w-5 text-emerald-400" />
        </div>
        <div>
          <h2 className="text-base font-black text-white" dir="ltr">606 MT5 MANUAL TRADING</h2>
          <p className="text-[11px] text-[#A1A1AA]" dir={isAr ? 'rtl' : 'ltr'}>
            {isAr
              ? `${connectedCount} / ${accountsCount} متصل  ·  نفس الأمر لكل الحسابات`
              : `${connectedCount}/${accountsCount} connected · unified orders`}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <button
          onClick={onOpenLog}
          className="p-2 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 text-white/70 hover:text-white"
          data-testid="manual-open-log"
          title={isAr ? 'سجل الأوامر' : 'Orders log'}
        >
          <ScrollText className="h-4 w-4" />
        </button>
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="p-2 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 disabled:opacity-50"
          data-testid="manual-refresh"
          title={isAr ? 'تحديث' : 'Refresh'}
        >
          <RefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
        </button>
        <button
          onClick={onToggleSound}
          className={`p-2 rounded-lg border transition ${
            soundEnabled
              ? 'bg-[#d4af37]/15 border-[#d4af37]/40 text-[#d4af37] hover:bg-[#d4af37]/25'
              : 'bg-white/5 border-white/10 text-white/40 hover:text-white/70'
          }`}
          data-testid="manual-sound-toggle"
          title={
            soundEnabled
              ? (isAr ? 'إشعارات صوتية مفعّلة — اضغط لكتم' : 'Sound alerts ON — click to mute')
              : (isAr ? 'إشعارات صوتية مكتومة — اضغط للتفعيل' : 'Sound alerts OFF — click to enable')
          }
        >
          {soundEnabled ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
        </button>
        {/* Explicit "disconnect all" — appears only when any account is connected. */}
        {connectedCount > 0 && (
          <button
            onClick={onDisconnectAll}
            disabled={disconnecting}
            className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 border border-white/15 hover:bg-white/10 disabled:opacity-50 text-xs text-white/70"
            data-testid="manual-disconnect-all"
            title={isAr ? 'فصل كل الحسابات' : 'Disconnect every account'}
          >
            {disconnecting ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <PowerOff className="h-3.5 w-3.5" />}
            {isAr ? 'فصل الكل' : 'Disconnect all'}
          </button>
        )}
      </div>
    </div>
  );
}
